import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Helmet from 'react-helmet'
import { routerActions } from 'react-router-redux'
import { findWhere } from 'underscore'
import { CSSTransitionGroup } from 'react-transition-group'

import auth from '~/services/auth'
import Slide from './RegistrationParts/MasterSlide'

import { updateSessionUser } from '~/actions/sessions'
import { getAllInterests, getUserInterests } from '~/actions/interests'
import { getNotifications } from '~/actions/notifications'
import { getUserCamps } from '~/actions/camps'
import { getUserBookmarks } from '~/actions/bookmarks'
import { getUserViewHistory } from '~/actions/viewhistory'


class Registration extends React.Component {
    static propTypes = {
		animating: PropTypes.string,
		registration: PropTypes.object,
		session: PropTypes.object,
		history: PropTypes.object.isRequired
	};

    constructor(props) {
        super(props);

        const loggedOut = window.location.hash === 'loggedout';
        this.state = {
			loginOnly: props.location.pathname.replace(/\//g,'') === 'login',
			alreadyRegistered: props.location.pathname.replace(/\//g,'') === 'reregister',
			slide_number: props.session.status === 'registering' && !loggedOut ? 2 : 1,
			direction: 'next'
		};

    }

    componentWillMount() {
        // if( !this.props.session.sessionAllowed ) this.props.history.push('/discover')
        // if( !this.state.loginOnly && !this.props.match.params.stripe_customer_id ) window.location = 'http://boma.camp'
		if( this.props.interests.all.length < 1 ) this.props.getAllInterests()
	}

    componentDidUpdate() {
		// if( this.state.slide_number === 1 && 'user' in this.props.session && this.props.session.status == 'registering' ) this.slideChange('next')
		// if( this.state.slide_number === 1 && 'user' in this.props.session && this.props.session.status == 'registered'  ) {
		// 	this.props.getNotifications();
		// 	this.props.getUserCamps();
		// 	this.props.getUserInterests();
		// 	this.props.getUserBookmarks();
		// 	this.props.getUserViewHistory();
			// this.props.history.push('/');
		// }
	}

    increaseSlideNumber = () => {
		var newNumber = +this.state.slide_number + 1
		if( this.props.registration.slides && (this.props.registration.slides.length < newNumber) ) return false;
		this.setState({
			slide_number: newNumber
		})
	};

    decreaseSlideNumber = () => {
		var newNumber = +this.state.slide_number - 1
		if( newNumber < 1 ) return
		this.setState({
			slide_number: newNumber
		})
	};

    slideChange = (direction, returnedData) => {
		if( direction === 'next' ) { this.increaseSlideNumber() } else { this.decreaseSlideNumber() };
        this.setState({
        	direction: direction
        })
		// TODO: Check if the data is the same (no need to do this if so)
        if(returnedData) this.updateUser(returnedData)
	};

    updateUser = (returnedData) => {
		if( !returnedData || !this.props.session.user.ID ) return;
		this.props.dispatch( updateSessionUser(
			returnedData.core_data,
			returnedData.custom_data,
			returnedData.acf_data
		) )
	};

    getQueryVariable = (variable) => {
		var query = window.location.search.substring(1);
		if(!query) return '';
		var vars = query.split("&");
		for (var i=0;i<vars.length;i++) {
		var pair = vars[i].split("=");
		if(pair[0] == variable){return pair[1];}
		}
		return(false);
	};

    getError = () => {
		let hash = this.getQueryVariable('error');
		if(!hash) return;
		return (
			<p className="text-center lead text-white mbot50">
				{ ( () => {
					switch(hash) {
						case 'register_for_interests': 	return 'Create your account for access to interests'
						case 'restricted_access': 		return 'Register or login to access this.'
						default: 						return 'Sorry something went wrong. Please login'
					}
				} )() }
			</p>
		)
	};

    render() {

		var slides = this.props.registration.slides,
			slide = slides[ !!this.state.slide_number ? this.state.slide_number - 1 : 0 ];

		return (

			<div className="slide-transition"  id={slide + '-slide'}>

				{ this.state.loginOnly
					? <Helmet title="Login"
						meta={[
		                    {"name": "description", "content": "Log in to Five to Nine Club to start your entrepreneurship journey. Ask questions, learn and take inspiration from our community of founders and small business owners."},
		                    {"property": "og:title", "content": "Login"},
		                    {"property": "og:description", "content": "Log in to Five to Nine Club to start your entrepreneurship journey. Ask questions, learn and take inspiration from our community of founders and small business owners."},
		                    {"property": "og:type", "content": "website"},
		                    {"property": "og:url", "content": window.location.protocol + '//' + window.location.host + '/login/'}
		                ]} 
	                />
	                : <Helmet title="Register"
						meta={[
		                    {"name": "description", "content":"Sign up for Five to Nine Club and start your entrepreneurship journey. Ask our community of founders and small business owners questions, learn and grow your business idea. Join a camp, have a discussion, get inspired."},
		                    {"property": "og:title", "content": "Register"},
		                    {"property": "og:description", "content": "Sign up for Five to Nine Club and start your entrepreneurship journey. Ask our community of founders and small business owners questions, learn and grow your business idea. Join a camp, have a discussion, get inspired."},
		                    {"property": "og:type", "content": "website"},
		                    {"property": "og:url", "content": window.location.protocol + '//' + window.location.host + '/register/'}
		                ]} 
	                />
	            }

				<CSSTransitionGroup
					transitionName="slide"
					component="fieldset"
					transitionEnterTimeout={300} 
					transitionLeaveTimeout={300}>
					{this.getError()}
					{( slides &&
							<Slide 
								slideName={slide} 
								loginOnly={this.state.loginOnly}
								stripe_customer_id={this.props.match.params.stripe_customer_id}
								key={'slide_' + this.state.slide_number}
								changeSlide={this.slideChange}
								session={this.props.session}
								interests={this.props.interests.all}
								history={this.props.history}
								dispatch={this.props.dispatch} />
					)}
				</CSSTransitionGroup>

			</div>

		)
	}
}

const mapStateToProps = (state) => ({
	session: state.session,
	interests: state.interests,
	registration: state.registration,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getNotifications,
	getUserCamps,
	getUserInterests,
	getUserBookmarks,
	getUserViewHistory,
	getAllInterests,
}, dispatch);

export default withRouter(connect(
	mapStateToProps,
	mapDispatchToProps
)(Registration));


// WEBPACK FOOTER //
// ./src/js/views/Registration/index.jsx